import styled from 'styled-components';

const CartPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 0rem;
`;

export default CartPageContainer;
